import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography } from '@material-ui/core';
import { ticketContext } from '../TicketContext';
import { applicationContext } from 'helpers/services';


let AssegneeSuggestions = () => {
    let { assignableUsers } = useContext(applicationContext);
    let service = useContext(ticketContext);

    return (
        <div style={{ backgroundColor: '#efefef' }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Product</TableCell>
                        <TableCell>Condition</TableCell>
                        <TableCell>Assegnee</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.suggestions.map((suggestion, index) =>
                        <TableRow hover key={index}>
                            <TableCell>{suggestion.product}</TableCell>
                            <TableCell>{suggestion.productStatus}</TableCell>
                            <TableCell>{assignableUsers.find(x => x.email === suggestion.assignee)?.name}</TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {service.suggestions.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={5}>
                                <Typography variant="subtitle2">No ticket suggestions found</Typography>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        </div>
    );
}

export default AssegneeSuggestions;